{
  "account.delete-confirm": [
    {
      "type": 0,
      "value": "Delete Account"
    }
  ],
  "account.delete-confirmation-instruction": [
    {
      "type": 0,
      "value": "Please type DELETE MY ACCOUNT to confirm:"
    }
  ],
  "account.delete-confirmation-title": [
    {
      "type": 0,
      "value": "Are you absolutely sure?"
    }
  ],
  "account.delete-confirmation-warning": [
    {
      "type": 0,
      "value": "This action cannot be undone. This will permanently delete your account and remove all data from our servers."
    }
  ],
  "account.delete-warning": [
    {
      "type": 0,
      "value": "Tieni presente che non sarai in grado di recuperare nessuna mappa mentale che hai aggiunto. Tutte le tue informazioni verranno cancellate e non potranno essere ripristinate."
    }
  ],
  "account.delete-warning-collaborations": [
    {
      "type": 0,
      "value": "All shared mindmaps and collaborations"
    }
  ],
  "account.delete-warning-consequences": [
    {
      "type": 0,
      "value": "This will permanently delete:"
    }
  ],
  "account.delete-warning-data": [
    {
      "type": 0,
      "value": "All your personal data and account information"
    }
  ],
  "account.delete-warning-description": [
    {
      "type": 0,
      "value": "Once you delete your account, there is no going back. Please be certain."
    }
  ],
  "account.delete-warning-history": [
    {
      "type": 0,
      "value": "All account history and activity logs"
    }
  ],
  "account.delete-warning-mindmaps": [
    {
      "type": 0,
      "value": "All your mindmaps and their content"
    }
  ],
  "account.delete-warning-title": [
    {
      "type": 0,
      "value": "Delete Account"
    }
  ],
  "accountinfo.button": [
    {
      "type": 0,
      "value": "Accetta"
    }
  ],
  "accountinfo.deleteaccount": [
    {
      "type": 0,
      "value": "Elimina Account"
    }
  ],
  "accountinfo.email": [
    {
      "type": 0,
      "value": "Email"
    }
  ],
  "accountinfo.firstname": [
    {
      "type": 0,
      "value": "Nome"
    }
  ],
  "accountinfo.lastname": [
    {
      "type": 0,
      "value": "Cognome"
    }
  ],
  "accountinfo.personal-details": [
    {
      "type": 0,
      "value": "Personal Details"
    }
  ],
  "accountinfo.title": [
    {
      "type": 0,
      "value": "Informazioni account"
    }
  ],
  "action.cancel-button": [
    {
      "type": 0,
      "value": "Annulla"
    }
  ],
  "action.close-button": [
    {
      "type": 0,
      "value": "Chiudi"
    }
  ],
  "action.delete": [
    {
      "type": 0,
      "value": "Elimina"
    }
  ],
  "action.delete-description": [
    {
      "type": 0,
      "value": "Le mappe mentali eliminate non possono essere recuperate. Vuoi continuare?"
    }
  ],
  "action.delete-title": [
    {
      "type": 0,
      "value": "Elimina"
    }
  ],
  "action.duplicate": [
    {
      "type": 0,
      "value": "Duplica"
    }
  ],
  "action.export": [
    {
      "type": 0,
      "value": "Esporta"
    }
  ],
  "action.history": [
    {
      "type": 0,
      "value": "Cronologia"
    }
  ],
  "action.history-description": [
    {
      "type": 0,
      "value": "Elenco delle modifiche introdotte negli ultimi 90 giorni."
    }
  ],
  "action.history-title": [
    {
      "type": 0,
      "value": "Cronologia versioni"
    }
  ],
  "action.import": [
    {
      "type": 0,
      "value": "Importa"
    }
  ],
  "action.info": [
    {
      "type": 0,
      "value": "Info"
    }
  ],
  "action.label": [
    {
      "type": 0,
      "value": "Aggiungi Etichetta"
    }
  ],
  "action.new": [
    {
      "type": 0,
      "value": "Nuova mappa"
    }
  ],
  "action.open": [
    {
      "type": 0,
      "value": "Apri"
    }
  ],
  "action.print": [
    {
      "type": 0,
      "value": "Stampa"
    }
  ],
  "action.publish": [
    {
      "type": 0,
      "value": "Pubblica"
    }
  ],
  "action.rename": [
    {
      "type": 0,
      "value": "Rinomina"
    }
  ],
  "action.rename-description-placeholder": [
    {
      "type": 0,
      "value": "Descrizione"
    }
  ],
  "action.rename-name-placeholder": [
    {
      "type": 0,
      "value": "Nome"
    }
  ],
  "action.share": [
    {
      "type": 0,
      "value": "Condividi"
    }
  ],
  "admin.auth-type": [
    {
      "type": 0,
      "value": "Tipo di autenticazione"
    }
  ],
  "admin.change-password": [
    {
      "type": 0,
      "value": "Change password"
    }
  ],
  "admin.change-password-button": [
    {
      "type": 0,
      "value": "Change Password"
    }
  ],
  "admin.change-password-description": [
    {
      "type": 0,
      "value": "Change password for user: "
    },
    {
      "type": 1,
      "value": "email"
    }
  ],
  "admin.change-password-title": [
    {
      "type": 0,
      "value": "Change Password"
    }
  ],
  "admin.close": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "admin.confirm-password": [
    {
      "type": 0,
      "value": "Confirm Password"
    }
  ],
  "admin.delete": [
    {
      "type": 0,
      "value": "Elimina"
    }
  ],
  "admin.delete-user": [
    {
      "type": 0,
      "value": "Elimina utente"
    }
  ],
  "admin.edit": [
    {
      "type": 0,
      "value": "Modifica"
    }
  ],
  "admin.edit-user": [
    {
      "type": 0,
      "value": "Modifica utente"
    }
  ],
  "admin.lock-status": [
    {
      "type": 0,
      "value": "Stato blocco"
    }
  ],
  "admin.locked": [
    {
      "type": 0,
      "value": "Bloccato"
    }
  ],
  "admin.new-password": [
    {
      "type": 0,
      "value": "New Password"
    }
  ],
  "admin.password-error-facebook": [
    {
      "type": 0,
      "value": "This user is authenticated via Facebook. Password changes are not available for Facebook accounts. Please ask the user to manage their password through their Facebook account."
    }
  ],
  "admin.password-error-failed": [
    {
      "type": 0,
      "value": "Failed to change password"
    }
  ],
  "admin.password-error-google": [
    {
      "type": 0,
      "value": "This user is authenticated via Google. Password changes are not available for Google accounts. Please ask the user to manage their password through their Google account."
    }
  ],
  "admin.password-error-length": [
    {
      "type": 0,
      "value": "Password must be at least 6 characters"
    }
  ],
  "admin.password-error-mismatch": [
    {
      "type": 0,
      "value": "Passwords do not match"
    }
  ],
  "admin.public": [
    {
      "type": 0,
      "value": "Pubblico"
    }
  ],
  "admin.public-access": [
    {
      "type": 0,
      "value": "Accesso pubblico"
    }
  ],
  "admin.refresh": [
    {
      "type": 0,
      "value": "Aggiorna"
    }
  ],
  "admin.status": [
    {
      "type": 0,
      "value": "Stato"
    }
  ],
  "admin.status-active": [
    {
      "type": 0,
      "value": "Attivo"
    }
  ],
  "admin.status-clean": [
    {
      "type": 0,
      "value": "Pulisci"
    }
  ],
  "admin.status-inactive": [
    {
      "type": 0,
      "value": "Inattivo"
    }
  ],
  "admin.status-suspended": [
    {
      "type": 0,
      "value": "Sospeso"
    }
  ],
  "admin.suspend-user": [
    {
      "type": 0,
      "value": "Sospendi utente"
    }
  ],
  "admin.suspension-reason": [
    {
      "type": 0,
      "value": "Motivo sospensione"
    }
  ],
  "admin.suspension-status": [
    {
      "type": 0,
      "value": "Stato sospensione"
    }
  ],
  "admin.suspension.abuse": [
    {
      "type": 0,
      "value": "Abuso"
    }
  ],
  "admin.suspension.inactivity": [
    {
      "type": 0,
      "value": "Inattività"
    }
  ],
  "admin.suspension.manual-review": [
    {
      "type": 0,
      "value": "Revisione manuale"
    }
  ],
  "admin.suspension.other": [
    {
      "type": 0,
      "value": "Altro"
    }
  ],
  "admin.suspension.security-concern": [
    {
      "type": 0,
      "value": "Preoccupazione di sicurezza"
    }
  ],
  "admin.suspension.terms-violation": [
    {
      "type": 0,
      "value": "Violazione dei termini"
    }
  ],
  "admin.system.db.url": [
    {
      "type": 0,
      "value": "URL"
    }
  ],
  "admin.system.jvm": [
    {
      "type": 0,
      "value": "JVM"
    }
  ],
  "admin.system.memory": [
    {
      "type": 0,
      "value": "Memoria"
    }
  ],
  "admin.system.refresh": [
    {
      "type": 0,
      "value": "Aggiorna"
    }
  ],
  "admin.system.title": [
    {
      "type": 0,
      "value": "Informazioni di sistema"
    }
  ],
  "admin.unsuspend-user": [
    {
      "type": 0,
      "value": "Ripristina utente"
    }
  ],
  "admin.view-xml": [
    {
      "type": 0,
      "value": "Visualizza XML"
    }
  ],
  "changepwd.button": [
    {
      "type": 0,
      "value": "Cambia"
    }
  ],
  "changepwd.confirm-password": [
    {
      "type": 0,
      "value": "Conferma Password"
    }
  ],
  "changepwd.description": [
    {
      "type": 0,
      "value": "Per favore, fornisci la nuova password per il tuo account."
    }
  ],
  "changepwd.password": [
    {
      "type": 0,
      "value": "Password"
    }
  ],
  "changepwd.password-match": [
    {
      "type": 0,
      "value": "Le password non corrispondono. Per favore, riprova."
    }
  ],
  "changepwd.title": [
    {
      "type": 0,
      "value": "Cambia Password"
    }
  ],
  "common.allow-email-notifications": [
    {
      "type": 0,
      "value": "Consenti notifiche email"
    }
  ],
  "common.delete": [
    {
      "type": 0,
      "value": "Elimina"
    }
  ],
  "common.delete-tag": [
    {
      "type": 0,
      "value": "Elimina tag"
    }
  ],
  "common.email": [
    {
      "type": 0,
      "value": "Email"
    }
  ],
  "common.emails": [
    {
      "type": 0,
      "value": "Email"
    }
  ],
  "common.first-name": [
    {
      "type": 0,
      "value": "Nome"
    }
  ],
  "common.last-name": [
    {
      "type": 0,
      "value": "Cognome"
    }
  ],
  "common.loading": [
    {
      "type": 0,
      "value": "Caricamento..."
    }
  ],
  "common.locale": [
    {
      "type": 0,
      "value": "Lingua"
    }
  ],
  "common.login-form": [
    {
      "type": 0,
      "value": "Modulo di accesso"
    }
  ],
  "common.maps-list": [
    {
      "type": 0,
      "value": "Elenco mappe"
    }
  ],
  "common.open-drawer": [
    {
      "type": 0,
      "value": "Apri menu"
    }
  ],
  "common.others": [
    {
      "type": 0,
      "value": "Altri"
    }
  ],
  "common.refresh": [
    {
      "type": 0,
      "value": "Aggiorna"
    }
  ],
  "common.registration-form": [
    {
      "type": 0,
      "value": "Modulo di registrazione"
    }
  ],
  "common.retry": [
    {
      "type": 0,
      "value": "Riprova"
    }
  ],
  "common.settings": [
    {
      "type": 0,
      "value": "Impostazioni"
    }
  ],
  "common.wait": [
    {
      "type": 0,
      "value": "Per favore attendi..."
    }
  ],
  "create.button": [
    {
      "type": 0,
      "value": "Crea"
    }
  ],
  "create.description": [
    {
      "type": 0,
      "value": "Per favore, inserisci il nome e la descrizione della nuova mappa."
    }
  ],
  "create.title": [
    {
      "type": 0,
      "value": "Crea una nuova mappa mentale"
    }
  ],
  "deletem.title": [
    {
      "type": 0,
      "value": "Tutte le mappe selezionate verranno eliminate"
    }
  ],
  "dialog.loading": [
    {
      "type": 0,
      "value": "Caricamento..."
    }
  ],
  "duplicate.copy-prefix": [
    {
      "type": 0,
      "value": "Copia di "
    }
  ],
  "duplicate.title": [
    {
      "type": 0,
      "value": "Duplica"
    }
  ],
  "error.generic-message": [
    {
      "type": 0,
      "value": "Riprova più tardi o contatta il supporto se il problema continua."
    }
  ],
  "error.generic-title": [
    {
      "type": 0,
      "value": "Abbiamo riscontrato un problema."
    }
  ],
  "error.map-title-required": [
    {
      "type": 0,
      "value": "Il titolo della mappa è obbligatorio e non può essere vuoto"
    }
  ],
  "error.map-unavailable-message": [
    {
      "type": 0,
      "value": "Questa mappa mentale non è disponibile per la visualizzazione pubblica perché viola le nostre politiche del sito. Se hai bisogno di ulteriore assistenza, contatta support@wisemapping.com."
    }
  ],
  "error.map-unavailable-title": [
    {
      "type": 0,
      "value": "Questa mappa mentale non è disponibile per la visualizzazione pubblica."
    }
  ],
  "error.not-found-message": [
    {
      "type": 0,
      "value": "La pagina che stai cercando potrebbe essere stata rimossa, rinominata o essere temporaneamente non disponibile."
    }
  ],
  "error.not-found-title": [
    {
      "type": 0,
      "value": "Non riusciamo a trovare questa pagina."
    }
  ],
  "error.page-title": [
    {
      "type": 0,
      "value": "Errore imprevisto | WiseMapping"
    }
  ],
  "error.permission-denied-message": [
    {
      "type": 0,
      "value": "Se ritieni di dover avere accesso, contatta il tuo amministratore."
    }
  ],
  "error.permission-denied-title": [
    {
      "type": 0,
      "value": "Non hai accesso a questa pagina."
    }
  ],
  "error.security-error": [
    {
      "type": 0,
      "value": "Non è possibile aprire la mappa mentale."
    }
  ],
  "error.undexpected-error-msg": [
    {
      "type": 0,
      "value": "Unexpected error opening mindmap. Please, try latter."
    }
  ],
  "expired.description": [
    {
      "type": 0,
      "value": "La tua sessione corrente è scaduta. Per favore, accedi e riprova."
    }
  ],
  "expired.title": [
    {
      "type": 0,
      "value": "La tua sessione è scaduta"
    }
  ],
  "export.desc": [
    {
      "type": 0,
      "value": "Esporta questa mappa nel formato che preferisci e inizia a usarla nelle tue presentazioni o condividila via email"
    }
  ],
  "export.document": [
    {
      "type": 0,
      "value": "Strumenti Mappa Mentale: Esporta la tua mappa mentale nei formati di strumenti di terze parti"
    }
  ],
  "export.document-label": [
    {
      "type": 0,
      "value": "Documento: Esporta la tua mappa mentale in un documento autonomo pronto da condividere"
    }
  ],
  "export.image": [
    {
      "type": 0,
      "value": "Immagine: Ottieni una rappresentazione grafica della tua mappa inclusi tutti i colori e le forme."
    }
  ],
  "export.img-center": [
    {
      "type": 0,
      "value": "Centra e adatta allo zoom"
    }
  ],
  "export.title": [
    {
      "type": 0,
      "value": "Esporta"
    }
  ],
  "export.warning": [
    {
      "type": 0,
      "value": "L'esportazione in Immagine (SVG,PNG,JPEG,PDF) è disponibile solo nella barra degli strumenti dell'editor."
    }
  ],
  "footer.aboutus": [
    {
      "type": 0,
      "value": "Chi Siamo"
    }
  ],
  "footer.contactus": [
    {
      "type": 0,
      "value": "Contattaci"
    }
  ],
  "footer.donations": [
    {
      "type": 0,
      "value": "Donazioni"
    }
  ],
  "footer.faq": [
    {
      "type": 0,
      "value": "F.A.Q."
    }
  ],
  "footer.faqandhelp": [
    {
      "type": 0,
      "value": "Aiuto & FAQ"
    }
  ],
  "footer.feedback": [
    {
      "type": 0,
      "value": "Feedback"
    }
  ],
  "footer.opensource": [
    {
      "type": 0,
      "value": "Open Source"
    }
  ],
  "footer.others": [
    {
      "type": 0,
      "value": "Altri"
    }
  ],
  "footer.support": [
    {
      "type": 0,
      "value": "Supporto"
    }
  ],
  "footer.team": [
    {
      "type": 0,
      "value": "Il Nostro Team"
    }
  ],
  "footer.termsandconditions": [
    {
      "type": 0,
      "value": "Termini e Condizioni"
    }
  ],
  "footer.privacypolicy": [
    {
      "type": 0,
      "value": "Informativa sulla Privacy"
    }
  ],
  "forgot.desc": [
    {
      "type": 0,
      "value": "Ti invieremo un'email per reimpostare la tua password."
    }
  ],
  "forgot.email": [
    {
      "type": 0,
      "value": "Email"
    }
  ],
  "forgot.oauth.back": [
    {
      "type": 0,
      "value": "Torna al login"
    }
  ],
  "forgot.oauth.message": [
    {
      "type": 0,
      "value": "Non hai bisogno di una password, per favore accedi usando Facebook o Google."
    }
  ],
  "forgot.page-title": [
    {
      "type": 0,
      "value": "Password Dimenticata | WiseMapping"
    }
  ],
  "forgot.register": [
    {
      "type": 0,
      "value": "Invia link di recupero"
    }
  ],
  "forgot.success.desc": [
    {
      "type": 0,
      "value": "Ti abbiamo inviato un'email che ti permetterà di reimpostare la tua password. Dovresti riceverla nei prossimi minuti."
    }
  ],
  "forgot.success.title": [
    {
      "type": 0,
      "value": "La tua password temporanea è stata inviata."
    }
  ],
  "forgot.title": [
    {
      "type": 0,
      "value": "Reimposta la tua password"
    }
  ],
  "forgotsuccess.page-title": [
    {
      "type": 0,
      "value": "Password Recuperata | WiseMapping"
    }
  ],
  "header.donthaveaccount": [
    {
      "type": 0,
      "value": "Non hai un account?"
    }
  ],
  "header.haveaccount": [
    {
      "type": 0,
      "value": "Hai già un account?"
    }
  ],
  "help.support": [
    {
      "type": 0,
      "value": "Supporto"
    }
  ],
  "history.no-changes": [
    {
      "type": 0,
      "value": "Non ci sono modifiche disponibili"
    }
  ],
  "import.button": [
    {
      "type": 0,
      "value": "Crea"
    }
  ],
  "import.description": [
    {
      "type": 0,
      "value": "Puoi importare mappe WiseMapping, FreeMind, Freeplane, XMind, MindManager e OPML nella tua lista di mappe. Seleziona il file che vuoi importare."
    }
  ],
  "import.error-file": [
    {
      "type": 0,
      "value": "Errore di importazione "
    },
    {
      "type": 1,
      "value": "error"
    }
  ],
  "import.title": [
    {
      "type": 0,
      "value": "Importa mappa mentale esistente"
    }
  ],
  "info.basic-info": [
    {
      "type": 0,
      "value": "Informazioni Base"
    }
  ],
  "info.button": [
    {
      "type": 0,
      "value": "Accetta"
    }
  ],
  "info.creation-time": [
    {
      "type": 0,
      "value": "Data di Creazione"
    }
  ],
  "info.creator": [
    {
      "type": 0,
      "value": "Creatore"
    }
  ],
  "info.description": [
    {
      "type": 0,
      "value": "Descrizione"
    }
  ],
  "info.description-msg": [
    {
      "type": 0,
      "value": "Pubblicando la mappa la rendi visibile a tutti su Internet."
    }
  ],
  "info.modified-time": [
    {
      "type": 0,
      "value": "Data Ultima Modifica"
    }
  ],
  "info.modified-tny": [
    {
      "type": 0,
      "value": "Ultima Modifica Di"
    }
  ],
  "info.name": [
    {
      "type": 0,
      "value": "Nome"
    }
  ],
  "info.public-visibility": [
    {
      "type": 0,
      "value": "Pubblicamente Visibile"
    }
  ],
  "info.sharing": [
    {
      "type": 0,
      "value": "Condivisione"
    }
  ],
  "info.starred": [
    {
      "type": 0,
      "value": "Preferiti"
    }
  ],
  "info.title": [
    {
      "type": 0,
      "value": "Info"
    }
  ],
  "label.add-button": [
    {
      "type": 0,
      "value": "Aggiungi etichetta"
    }
  ],
  "label.add-for": [
    {
      "type": 0,
      "value": "Modifica etichette per"
    }
  ],
  "label.add-placeholder": [
    {
      "type": 0,
      "value": "Titolo etichetta"
    }
  ],
  "label.change-color": [
    {
      "type": 0,
      "value": "Cambia colore etichetta"
    }
  ],
  "label.delete-description": [
    {
      "type": 0,
      "value": "verrà eliminata, incluse le sue associazioni a tutte le mappe esistenti. Vuoi continuare?"
    }
  ],
  "label.delete-title": [
    {
      "type": 0,
      "value": "Conferma eliminazione etichetta"
    }
  ],
  "label.description": [
    {
      "type": 0,
      "value": "Usa le etichette per organizzare le tue mappe."
    }
  ],
  "label.maps-count": [
    {
      "type": 1,
      "value": "count"
    },
    {
      "type": 0,
      "value": " mappe"
    }
  ],
  "label.title": [
    {
      "type": 0,
      "value": "Aggiungi un'etichetta"
    }
  ],
  "language.change": [
    {
      "type": 0,
      "value": "Cambia Lingua"
    }
  ],
  "language.help": [
    {
      "type": 0,
      "value": "Aiuta a Tradurre"
    }
  ],
  "login.desc": [
    {
      "type": 0,
      "value": "Accedi al tuo account"
    }
  ],
  "login.division": [
    {
      "type": 0,
      "value": "o"
    }
  ],
  "login.email": [
    {
      "type": 0,
      "value": "Email"
    }
  ],
  "login.error": [
    {
      "type": 0,
      "value": "L'indirizzo email o la password inseriti non sono validi."
    }
  ],
  "login.facebook.button": [
    {
      "type": 0,
      "value": "Accedi con Facebook"
    }
  ],
  "login.forgotpwd": [
    {
      "type": 0,
      "value": "Password Dimenticata?"
    }
  ],
  "login.google.button": [
    {
      "type": 0,
      "value": "Accedi con Google"
    }
  ],
  "login.page-title": [
    {
      "type": 0,
      "value": "Login | WiseMapping"
    }
  ],
  "login.password": [
    {
      "type": 0,
      "value": "Password"
    }
  ],
  "login.remberme": [
    {
      "type": 0,
      "value": "Ricordami"
    }
  ],
  "login.shared-map-notice": [
    {
      "type": 0,
      "value": "Una mappa mentale è stata condivisa con te. Effettua il login per accedervi. Non hai un account? Registrati gratuitamente o usa il tuo account Google/Facebook."
    }
  ],
  "login.signin": [
    {
      "type": 0,
      "value": "Accedi"
    }
  ],
  "login.signup": [
    {
      "type": 0,
      "value": "Registrati"
    }
  ],
  "login.title": [
    {
      "type": 0,
      "value": "Benvenuto"
    }
  ],
  "map.creator": [
    {
      "type": 0,
      "value": "Creatore"
    }
  ],
  "map.delete-selected": [
    {
      "type": 0,
      "value": "Elimina selezionati"
    }
  ],
  "map.last-update": [
    {
      "type": 0,
      "value": "Ultimo Aggiornamento"
    }
  ],
  "map.more-actions": [
    {
      "type": 0,
      "value": "Altre Azioni"
    }
  ],
  "map.name": [
    {
      "type": 0,
      "value": "Nome"
    }
  ],
  "map.tooltip-add": [
    {
      "type": 0,
      "value": "Aggiungi etichetta ai selezionati"
    }
  ],
  "maps.choose-file": [
    {
      "type": 0,
      "value": "Scegli un file"
    }
  ],
  "maps.copilot-button": [
    {
      "type": 0,
      "value": "Copilota IA"
    }
  ],
  "maps.copilot-dialog.continue": [
    {
      "type": 0,
      "value": "Apri il Copilota"
    }
  ],
  "maps.copilot-dialog.description": [
    {
      "type": 0,
      "value": "Mind Map Copilot è un assistente di brainstorming basato su ChatGPT che trasforma i tuoi prompt in mappe mentali strutturate. Lo apriremo in una nuova scheda così potrai ampliare le idee, generare argomenti e riportare il meglio in WiseMapping."
    }
  ],
  "maps.copilot-dialog.title": [
    {
      "type": 0,
      "value": "Copilota Mindmap con tecnologia ChatGPT"
    }
  ],
  "maps.copilot-tooltip": [
    {
      "type": 0,
      "value": "Avvia una mappa mentale con il Copilota IA"
    }
  ],
  "maps.create-tooltip": [
    {
      "type": 0,
      "value": "Crea una nuova mappa mentale"
    }
  ],
  "maps.empty-result": [
    {
      "type": 0,
      "value": "Nessuna mappa mentale trovata con i criteri di filtro correnti."
    }
  ],
  "maps.import-desc": [
    {
      "type": 0,
      "value": "Importa da altri strumenti"
    }
  ],
  "maps.modified": [
    {
      "type": 0,
      "value": "Modificato"
    }
  ],
  "maps.modified-by": [
    {
      "type": 0,
      "value": "Modificato Da"
    }
  ],
  "maps.modified-by-desc": [
    {
      "type": 0,
      "value": "Modificato da "
    },
    {
      "type": 1,
      "value": "by"
    },
    {
      "type": 0,
      "value": " il "
    },
    {
      "type": 1,
      "value": "on"
    }
  ],
  "maps.nav-all": [
    {
      "type": 0,
      "value": "Tutte"
    }
  ],
  "maps.nav-onwned": [
    {
      "type": 0,
      "value": "Possedute"
    }
  ],
  "maps.nav-public": [
    {
      "type": 0,
      "value": "Pubbliche"
    }
  ],
  "maps.nav-shared": [
    {
      "type": 0,
      "value": "Condivise con me"
    }
  ],
  "maps.nav-starred": [
    {
      "type": 0,
      "value": "Preferiti"
    }
  ],
  "maps.page-title": [
    {
      "type": 0,
      "value": "Le Mie Mappe | WiseMapping"
    }
  ],
  "maps.revert": [
    {
      "type": 0,
      "value": "Ripristina"
    }
  ],
  "maps.search-action": [
    {
      "type": 0,
      "value": "Cerca..."
    }
  ],
  "maps.tooltip-open": [
    {
      "type": 0,
      "value": "Apri per modificare"
    }
  ],
  "maps.tooltip-starred": [
    {
      "type": 0,
      "value": "Preferiti"
    }
  ],
  "maps.untitled": [
    {
      "type": 0,
      "value": "Senza titolo"
    }
  ],
  "maps.view": [
    {
      "type": 0,
      "value": "Visualizza"
    }
  ],
  "menu.account": [
    {
      "type": 0,
      "value": "Account"
    }
  ],
  "menu.admin-console": [
    {
      "type": 0,
      "value": "Admin Console"
    }
  ],
  "menu.change-password": [
    {
      "type": 0,
      "value": "Cambia password"
    }
  ],
  "menu.signout": [
    {
      "type": 0,
      "value": "Esci"
    }
  ],
  "publish.button": [
    {
      "type": 0,
      "value": "Accetta"
    }
  ],
  "publish.checkbox": [
    {
      "type": 0,
      "value": "Abilita condivisione pubblica"
    }
  ],
  "publish.copied": [
    {
      "type": 0,
      "value": "Copied to clipboard!"
    }
  ],
  "publish.description": [
    {
      "type": 0,
      "value": "Pubblicando la mappa la rendi visibile a tutti su Internet."
    }
  ],
  "publish.embedded": [
    {
      "type": 0,
      "value": "Incorporato"
    }
  ],
  "publish.embedded-msg": [
    {
      "type": 0,
      "value": "Copia questo frammento di codice per incorporarlo nel tuo blog o pagina:"
    }
  ],
  "publish.public-url": [
    {
      "type": 0,
      "value": "URL Pubblico"
    }
  ],
  "publish.public-url-msg": [
    {
      "type": 0,
      "value": "Copia e incolla il link sottostante per condividere la tua mappa con i colleghi:"
    }
  ],
  "publish.title": [
    {
      "type": 0,
      "value": "Pubblica"
    }
  ],
  "registation.callback.error.message": [
    {
      "type": 0,
      "value": "Si è verificato un errore durante la validazione della tua identità con Google, puoi riprovare dalla pagina di login"
    }
  ],
  "registation.success-title": [
    {
      "type": 0,
      "value": "Registrazione Riuscita | WiseMapping"
    }
  ],
  "registration.callback.back": [
    {
      "type": 0,
      "value": "Torna al login"
    }
  ],
  "registration.callback.confirm.description": [
    {
      "type": 0,
      "value": "Un account con la stessa email è stato registrato in precedenza. Vuoi collegare il tuo account "
    },
    {
      "type": 1,
      "value": "provider"
    },
    {
      "type": 0,
      "value": " a quell'account WiseMapping?"
    }
  ],
  "registration.callback.confirm.title": [
    {
      "type": 0,
      "value": "Conferma"
    }
  ],
  "registration.callback.sync": [
    {
      "type": 0,
      "value": "Sincronizza account"
    }
  ],
  "registration.callback.waiting.description": [
    {
      "type": 0,
      "value": "Per favore attendi mentre convalidiamo la tua identità"
    }
  ],
  "registration.callback.waiting.title": [
    {
      "type": 0,
      "value": "Finalizzando..."
    }
  ],
  "registration.desc": [
    {
      "type": 0,
      "value": "La registrazione è gratuita e richiede solo un momento"
    }
  ],
  "registration.division": [
    {
      "type": 0,
      "value": "o"
    }
  ],
  "registration.email": [
    {
      "type": 0,
      "value": "Email"
    }
  ],
  "registration.error.title": [
    {
      "type": 0,
      "value": "Registrazione Fallita"
    }
  ],
  "registration.facebook.button": [
    {
      "type": 0,
      "value": "Registrati con Facebook"
    }
  ],
  "registration.firstname": [
    {
      "type": 0,
      "value": "Nome"
    }
  ],
  "registration.form-legend": [
    {
      "type": 0,
      "value": "Account Information"
    }
  ],
  "registration.google.button": [
    {
      "type": 0,
      "value": "Registrati con Google"
    }
  ],
  "registration.lastname": [
    {
      "type": 0,
      "value": "Cognome"
    }
  ],
  "registration.page-title": [
    {
      "type": 0,
      "value": "Registrazione | WiseMapping"
    }
  ],
  "registration.password": [
    {
      "type": 0,
      "value": "Password"
    }
  ],
  "registration.register": [
    {
      "type": 0,
      "value": "Registrati"
    }
  ],
  "registration.success.desc": [
    {
      "type": 0,
      "value": "Clicca il pulsante 'Accedi' qui sotto e inizia a creare mappe mentali."
    }
  ],
  "registration.termandconditions": [
    {
      "type": 0,
      "value": "Ho letto e accetto i "
    },
    {
      "type": 8,
      "value": "termsLink",
      "children": [
        {
          "type": 0,
          "value": "Termini di Utilizzo"
        }
      ]
    },
    {
      "type": 0,
      "value": " e l'"
    },
    {
      "type": 8,
      "value": "privacyLink",
      "children": [
        {
          "type": 0,
          "value": "Informativa sulla Privacy"
        }
      ]
    }
  ],
  "registration.title": [
    {
      "type": 0,
      "value": "Diventa un membro"
    }
  ],
  "rename.description": [
    {
      "type": 0,
      "value": "Per favore, inserisci il nuovo nome e descrizione della mappa."
    }
  ],
  "rename.title": [
    {
      "type": 0,
      "value": "Rinomina"
    }
  ],
  "resetpassword.success.title": [
    {
      "type": 0,
      "value": "Il tuo account è stato creato con successo"
    }
  ],
  "role.editor": [
    {
      "type": 0,
      "value": "Editor"
    }
  ],
  "role.owner": [
    {
      "type": 0,
      "value": "Proprietario"
    }
  ],
  "role.viewer": [
    {
      "type": 0,
      "value": "Visualizzatore"
    }
  ],
  "share.add-button": [
    {
      "type": 0,
      "value": "Condividi"
    }
  ],
  "share.add-message": [
    {
      "type": 0,
      "value": "Aggiungi messaggio"
    }
  ],
  "share.adding-button": [
    {
      "type": 0,
      "value": "Sharing..."
    }
  ],
  "share.can-edit": [
    {
      "type": 0,
      "value": "Può modificare"
    }
  ],
  "share.can-view": [
    {
      "type": 0,
      "value": "Può visualizzare"
    }
  ],
  "share.delete": [
    {
      "type": 0,
      "value": "Elimina collaboratore"
    }
  ],
  "share.delete-description": [
    {
      "type": 0,
      "value": "Aggiungi collaboratori. Riceveranno accesso istantaneo via email per modificare insieme."
    }
  ],
  "share.delete-title": [
    {
      "type": 0,
      "value": "Condividi con persone"
    }
  ],
  "share.message": [
    {
      "type": 0,
      "value": "Messaggio"
    }
  ],
  "theme.dark": [
    {
      "type": 0,
      "value": "Scuro"
    }
  ],
  "theme.light": [
    {
      "type": 0,
      "value": "Chiaro"
    }
  ],
  "theme.toggle": [
    {
      "type": 0,
      "value": "Cambia Tema"
    }
  ],
  "validation.title-required": [
    {
      "type": 0,
      "value": "Il titolo è obbligatorio"
    }
  ]
}
